import { render, staticRenderFns } from "./DeclaredGoodsSite.vue?vue&type=template&id=e0497ba4&scoped=true"
import script from "./DeclaredGoodsSite.vue?vue&type=script&lang=js"
export * from "./DeclaredGoodsSite.vue?vue&type=script&lang=js"
import style0 from "./DeclaredGoodsSite.vue?vue&type=style&index=0&id=e0497ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0497ba4",
  null
  
)

export default component.exports